module.exports = "https://www.gc-qa.gnp.com.mx/fd8584b8a25ebb0e3972cdc16c3b8a05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/check_green.svg
// module id = 1803
// module chunks = 0